import React from 'react';
import PropTypes from 'prop-types';
import { EmptyStateText, EmptyStateIcon, CenteredEmptyState } from './style';
import dumbbell from '../../images/dumbbell.svg';

const EmptyState = ({ text, ...rest }) => {
  return (
    <CenteredEmptyState {...rest}>
      <EmptyStateIcon src={dumbbell} alt="Empty state" />
      <EmptyStateText>{text}</EmptyStateText>
    </CenteredEmptyState>
  );
};

export default EmptyState;

EmptyState.propTypes = {
  text: PropTypes.string.isRequired,
};
